import { Link, Outlet } from '@tanstack/react-router';
import { Boxes, Package, Settings, Tags } from 'lucide-react';
import { SessionBanner } from '../components/SessionBanner';

export function RootLayout() {
  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="brand">
          <img src="/logo.webp" alt="NCC Heavy Duty" />
          <div className="brand-text">
            <span className="top">NCC Heavy Duty</span>
            <span className="sub">Catalogue admin</span>
          </div>
        </div>

        <nav>
          <Link to="/" activeOptions={{ exact: true }} activeProps={{ className: 'active' }}>
            <Boxes size={16} /> Inventory
          </Link>
          <Link to="/parts" activeProps={{ className: 'active' }}>
            <Package size={16} /> Parts
          </Link>
          <Link to="/products" activeProps={{ className: 'active' }}>
            <Tags size={16} /> Products
          </Link>
          <Link to="/settings/lookups" activeProps={{ className: 'active' }}>
            <Settings size={16} /> Settings
          </Link>
        </nav>

        <div className="footer">Build {import.meta.env.MODE}</div>
      </aside>
      <main className="main">
        <SessionBanner />
        <Outlet />
      </main>
    </div>
  );
}
